import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { BrowserRouter } from 'react-router-dom';
import { SnackbarProvider } from "notistack";
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import StyledEngineProvider from '@mui/material/StyledEngineProvider';

const theme = createTheme({
  palette: {
    primary: {
      main: '#00bcd4'
    },
    secondary: {
      main: '#b2ebf2'
    },
    black: {
      main: '#333333'
    }
  },
  zIndex: {
    tooltip: 1150
  }
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <StyledEngineProvider injectFirst>
    <Provider store={store}>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <SnackbarProvider>
            <App />
          </SnackbarProvider>
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  </StyledEngineProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
